module.exports = __webpack_public_path__ + "img/black3.bdf24ac4.png";